module.exports = __webpack_public_path__ + "static/media/new-thumbnail.22127ab9.PNG";